import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { CardProgrammerStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Unset key store action for card programmer
 */
export const cardProgrammerUnsetKeyStoreAction = createAction(
  CardProgrammerStoreAction.CARD_PROGRAMMER_UNSET_KEY_STORAGE
);

/**
 * Start load card programmer list action
 */
export const cardProgrammerStartLoadAction = createAction(
  CardProgrammerStoreAction.CARD_PROGRAMMER_START_LOAD
);

/**
 * Card programmer load list success
 */
export const cardProgrammerLoadSuccessAction = createAction(
  CardProgrammerStoreAction.CARD_PROGRAMMER_LOAD_SUCCES,
  props<{ listCardProgrammerObject: GenericApiData }>()
);

/**
 * Card programmer load list error
 */
export const cardProgrammerLoadErrorAction = createAction(
  CardProgrammerStoreAction.CARD_PROGRAMMER_LOAD_ERROR
);
